import UserLayout from "../../components/UserLayout";
import CreatePost from "../../components/user/posts/CreatePost";

const CreatePostPage = () => {
    return (
        <UserLayout>
            <CreatePost />
        </UserLayout>
    );
}

export default CreatePostPage;